"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPenTool = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11.5 10.12a1 1 0 101 0V3.016c.04-.645.313-.977.818-.998.505-.021.858.151 1.059.517l2.944 7.458c.447 1.03.674 1.701.68 2.011.005.31-.063.623-.205.939l-2.242 3.94c-.18.302-.396.562-.647.778-.252.217-.632.325-1.141.325h-3.532c-.444 0-.81-.108-1.099-.325a2.519 2.519 0 01-.688-.778L6.219 12.95A2.072 2.072 0 016 12.01c.006-.31.238-.984.697-2.024l2.927-7.45C9.793 2.18 10.138 2 10.658 2c.521 0 .802.34.842 1.02v7.1zM10 19.986h4c.667 0 1 .333 1 1s-.333 1-1 1h-4c-.666 0-1-.333-1-1s.334-1 1-1z' }))); };
exports.default = SvgPenTool;
//# sourceMappingURL=PenTool.js.map